import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import {
  getPhase4DisclosureCopy,
  type Phase4DisclosureCopy,
  type Phase4DisclosureSurface,
} from "@/integrations/multiresume/compliance/trust-copy";
import { cn } from "@/utils/style";

import { TrustLinks } from "./trust-links";

type DisclosureNoticeProps = {
  surface: Phase4DisclosureSurface;
  className?: string;
  copy?: Phase4DisclosureCopy;
  openLinksInNewTab?: boolean;
};

export function DisclosureNotice({
  surface,
  className,
  copy = getPhase4DisclosureCopy(surface),
  openLinksInNewTab = false,
}: DisclosureNoticeProps) {
  return (
    <Alert className={cn("bg-card", className)}>
      <AlertTitle>{copy.title}</AlertTitle>
      <AlertDescription className="space-y-3">
        <p>{copy.body}</p>
        <ul className="list-disc space-y-1 ps-5">
          {copy.bullets.map((bullet) => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
        <TrustLinks links={copy.links} className="text-xs text-muted-foreground" openInNewTab={openLinksInNewTab} />
      </AlertDescription>
    </Alert>
  );
}
